<app-kpi-widget
  [title]="'executiveStats.widgets.costPerKilometer' | transloco"
  [isLoading]="isLoading"
  icon="ph-road-horizon"
  [totalValue]="value"
  [totalCost]="cost"
  [percentageDifference]="percentageDifference"
  [costDifference]="difference"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [dropdownOptions]="dropdownOptions"
  [isUptrendPositive]="isUptrendPositive"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [dropdownEnabled]="false"
  [isImageIcon]="false"
></app-kpi-widget>